(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-search-template"]) return;
  try {
    
document.querySelectorAll('.hof-native-search').forEach(section => {
  section.querySelectorAll('[data-columns]').forEach(button => {
    button.addEventListener('click', () => {
      section.style.setProperty('--hof-columns', button.dataset.columns);
      section.querySelectorAll('[data-columns]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    });
  });
});
const nativeSearchLocation = new URL(location.href);
if (!nativeSearchLocation.searchParams.has('q') && nativeSearchLocation.searchParams.has('term')) {
  nativeSearchLocation.searchParams.set('q', nativeSearchLocation.searchParams.get('term'));
  nativeSearchLocation.searchParams.delete('term');
  nativeSearchLocation.searchParams.set('type', 'product');
  location.replace(nativeSearchLocation.href);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-teaser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hof-studio-invitation')) {
    customElements.define('hof-studio-invitation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-pin-form]');
        const input = form.elements.studio_code;
        const error = this.querySelector('[data-pin-error]');
        const gate = this.querySelector('[data-gate]');
        const reveal = this.querySelector('[data-reveal]');
        const code = this.dataset.code || '';
        const key = 'houseof-studio-invitation:' + code;
        const show = (unlocked, focus) => {
          gate.hidden = unlocked;
          reveal.hidden = !unlocked;
          if (focus) {
            (unlocked ? this.querySelector('[data-reveal-title]') : input).focus();
            this.scrollIntoView({ block:'start', behavior:'instant' });
          }
        };
        try { if (/^[0-9]{4}$/.test(code) && sessionStorage.getItem(key) === 'open') show(true, false); } catch (_) {}
        if (this.querySelector('[data-application-status]')) {
          show(false, false);
          this.querySelector('.studio-invitation__signup').open = true;
        }
        input.addEventListener('input', () => {
          input.value = input.value.replace(/[^0-9]/g, '').slice(0, 4);
          input.removeAttribute('aria-invalid');
          error.hidden = true;
        });
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (/^[0-9]{4}$/.test(code) && input.value === code) {
            try { sessionStorage.setItem(key, 'open'); } catch (_) {}
            error.hidden = true;
            show(true, true);
          } else {
            error.hidden = false;
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            input.select();
          }
        });
        this.querySelector('[data-lock]').addEventListener('click', () => {
          try { sessionStorage.removeItem(key); } catch (_) {}
          input.value = '';
          input.removeAttribute('aria-invalid');
          error.hidden = true;
          show(false, true);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
